<template>
  <v-card
    height="100%"
    dark
    class="d-flex justify-center align-center transparent pa-5 py-10"
  >
    <v-card
      max-width="900px"
      min-width="100px"
      class="mx-auto"
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <Who v-if="page === 0" />
      <What v-if="page === 1" />
      <Why v-if="page === 2" />
    </v-card>
    <v-card v-else>
      <WhoMobile v-if="page === 0" />
      <WhatMobile v-if="page === 1" />
      <WhyMobile v-if="page === 2" />
    </v-card>
  </v-card>
</template>

<script>
import Who from "../components/About/Who";
import What from "../components/About/What";
import Why from "../components/About/Why";

import WhoMobile from "../components/AboutMobile/WhoMobile";
import WhatMobile from "../components/AboutMobile/WhatMobile";
import WhyMobile from "../components/AboutMobile/WhyMobile";

import { mapState } from "vuex";

export default {
  components: {
    Who,
    What,
    Why,
    WhoMobile,
    WhatMobile,
    WhyMobile
  },
  data: () => ({
    texts: [
      {
        title: "Who?",
        img:
          "https://lh3.googleusercontent.com/UdVgHEOVZm30cUPw5wANFMkBz7fyUJnTuIjWtNJ2SdEQTOBT_MhtZlrbevia7FvY3MwncmfnP0zD5O2XjUeeYRzjBDEDr6xKYPV6R_cGD2Qih6ps_mlkHFhXms1m1Ee7LugUYmlzdANqmLBpZCJ-vOSa9WIGo9yLwp6Q8mpcqx_D_dC1sz9mITBTkGgJpbOKHDQVD3kTyFGMz9WiVUnjm4QucABTYBrGlJfjYW3IA8q6ZocdbvmNwLVYNQkogzBnmSzfR3enCQvf3lAksyK4-SCp_YcCDqnHtGxNgiobW7d61jBERwaaKwzob8da_gFy93FqmMh9zvWbuDRcG8KlLXY57iBdXe8moZFfdKhlG1Gn31vMf0-q1X3EdWwykwnGk2kDifSphnKOuj9sUwWS5G-8h13EZxFged4WoNVJZQMiPewWo9izHu93ApiAAxRuL8ZF0dWViEip-7Pm8it3hPT6ZtTKCQwv99QEw85vVjDBhUnSKdsB-Syzg0I0H9l4OOC8aXqQUnuTrL-mXeSJdIKEXkupyBZsCrKOpupZJVzGJhIgqdPmquM6vurTTUg42UgPQ3rNPUH0w8BdbzDJGX1vIjNzXWeNTX9rEA81032nubDY-uxp13Z_qjSot3EGmDTDfajau-aXPw-bbK_WNCJSiMfbQ8qdG80g1TM2g0kNfJUjGloHodg=w753-h1003-no"
      },
      {
        title: "What?",
        img:
          "https://lh3.googleusercontent.com/UdVgHEOVZm30cUPw5wANFMkBz7fyUJnTuIjWtNJ2SdEQTOBT_MhtZlrbevia7FvY3MwncmfnP0zD5O2XjUeeYRzjBDEDr6xKYPV6R_cGD2Qih6ps_mlkHFhXms1m1Ee7LugUYmlzdANqmLBpZCJ-vOSa9WIGo9yLwp6Q8mpcqx_D_dC1sz9mITBTkGgJpbOKHDQVD3kTyFGMz9WiVUnjm4QucABTYBrGlJfjYW3IA8q6ZocdbvmNwLVYNQkogzBnmSzfR3enCQvf3lAksyK4-SCp_YcCDqnHtGxNgiobW7d61jBERwaaKwzob8da_gFy93FqmMh9zvWbuDRcG8KlLXY57iBdXe8moZFfdKhlG1Gn31vMf0-q1X3EdWwykwnGk2kDifSphnKOuj9sUwWS5G-8h13EZxFged4WoNVJZQMiPewWo9izHu93ApiAAxRuL8ZF0dWViEip-7Pm8it3hPT6ZtTKCQwv99QEw85vVjDBhUnSKdsB-Syzg0I0H9l4OOC8aXqQUnuTrL-mXeSJdIKEXkupyBZsCrKOpupZJVzGJhIgqdPmquM6vurTTUg42UgPQ3rNPUH0w8BdbzDJGX1vIjNzXWeNTX9rEA81032nubDY-uxp13Z_qjSot3EGmDTDfajau-aXPw-bbK_WNCJSiMfbQ8qdG80g1TM2g0kNfJUjGloHodg=w753-h1003-no"
      },
      {
        title: "Why?",
        img:
          "https://lh3.googleusercontent.com/UdVgHEOVZm30cUPw5wANFMkBz7fyUJnTuIjWtNJ2SdEQTOBT_MhtZlrbevia7FvY3MwncmfnP0zD5O2XjUeeYRzjBDEDr6xKYPV6R_cGD2Qih6ps_mlkHFhXms1m1Ee7LugUYmlzdANqmLBpZCJ-vOSa9WIGo9yLwp6Q8mpcqx_D_dC1sz9mITBTkGgJpbOKHDQVD3kTyFGMz9WiVUnjm4QucABTYBrGlJfjYW3IA8q6ZocdbvmNwLVYNQkogzBnmSzfR3enCQvf3lAksyK4-SCp_YcCDqnHtGxNgiobW7d61jBERwaaKwzob8da_gFy93FqmMh9zvWbuDRcG8KlLXY57iBdXe8moZFfdKhlG1Gn31vMf0-q1X3EdWwykwnGk2kDifSphnKOuj9sUwWS5G-8h13EZxFged4WoNVJZQMiPewWo9izHu93ApiAAxRuL8ZF0dWViEip-7Pm8it3hPT6ZtTKCQwv99QEw85vVjDBhUnSKdsB-Syzg0I0H9l4OOC8aXqQUnuTrL-mXeSJdIKEXkupyBZsCrKOpupZJVzGJhIgqdPmquM6vurTTUg42UgPQ3rNPUH0w8BdbzDJGX1vIjNzXWeNTX9rEA81032nubDY-uxp13Z_qjSot3EGmDTDfajau-aXPw-bbK_WNCJSiMfbQ8qdG80g1TM2g0kNfJUjGloHodg=w753-h1003-no"
      }
    ]
  }),
  computed: {
    ...mapState(["page"])
  }
};
</script>

<style></style>
